/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 08.02.13, 13:31
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { Signal } from "signals.js";

/**
 * @private
 */
export class AbstractTextContentVO {
    public static NAME: string = "AbstractTextContentVO";
    public static MESSAGE_ERROR_COMPOSE_NOT_OVERRIDDEN: string = "Compose method is not implemented";
    public triggerUpdate: boolean = true;
    private _propertyChangedSignal: Signal;

    public get propertyChangedSignal(): Signal {
        if (!this._propertyChangedSignal) {
            this._propertyChangedSignal = new Signal();
        }

        return this._propertyChangedSignal;
    }

    public set propertyChangedSignal(value: Signal) {
        this._propertyChangedSignal = value;
    }

    public dispose(): void {
        if (this._propertyChangedSignal) {
            this._propertyChangedSignal.removeAll();
        }
    }

    public compose(): string {
        throw new Error(AbstractTextContentVO.MESSAGE_ERROR_COMPOSE_NOT_OVERRIDDEN);
    }

    public toString(): string {
        return AbstractTextContentVO.NAME;
    }
}
